import { AbstractModel } from './abstract-model';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class RideReview {
  @autoserialize
  reservationId: number;

  @autoserialize
  driverRating: number;
}
